/* globals hj */

function hotjarInit () {
  if (typeof window === 'undefined') return
  if (typeof window.hj !== 'undefined') return

  /* istanbul ignore next */
  window.hj = window.hj || function () {
    (hj.q = hj.q || []).push(arguments)
  }
}

module.exports = { hotjarInit }
